import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { clearSessionExpired } from "@/redux/SessionSlice";
import SuccessDialog from "@/Components/Dialog/SuccessDialog";
import { LuX } from "@/Components/Icons/Icons"; // exclamation/error icon

const SessionDialog = () => {
  const dispatch = useDispatch();
  const sessionExpired = useSelector((state) => state.session.expired);

  if (!sessionExpired) return null;

  const handleLogin = () => {
    dispatch(clearSessionExpired());
    localStorage.clear();
    window.location.href = `${import.meta.env.VITE_BASE_REDIRECT_URL}/login`;
  };

  return (
    <SuccessDialog
      open={sessionExpired}
      onClose={handleLogin}          // force login on click
      title="Your session has expired"
      subtitle="Please login again to continue."
      label="Session Expired"
      status="error"                 // red background
      buttonText="Login"
      IconComponent={LuX}            // exclamation/error icon
    />
  );
};

export default SessionDialog;

